export default "__VITE_ASSET__DeEVZ11t__"